export default import.meta.ROLLUP_FILE_URL_o9mTx72GavV3IFe_vMgEWw